/** Copy footer "Ganti device" — acuan: superoti/docs/06-specs/kitchen-delman-device-lifecycle.md §8 */
export const SWITCH_DEVICE_HINT =
  'Menghapus data lokal. Wajib minta Admin HO unbind device ini sebelum aktivasi perangkat pengganti.'
